<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal">
      <!-- Header mit Titel -->
      <div class="modal-header text-3xl" :class="{ 'row-reverse': rowReverse }">
        <slot name="header">{{ title }}</slot>
        <button class="modal-close" @click="close">
          <img src="files/lidl/images/new-icons/svg/close_black.svg" alt="Close" class="close-icon" />
        </button>
      </div>

      <!-- Body-Inhalt -->
      <div class="modal-body">
        <slot>
          Default Content
        </slot>
      </div>

      <!-- Footer mit Buttons -->
      <div class="modal-footer" :class="{ center: !showPrev || !showNext }">
        <button v-if="showPrev" :disabled="disablePrev" class="button button--secondary" @click="prevAction">
          <slot name="btnPrevTxt">{{ prevText }}</slot>
        </button>
        <button v-if="showNext" :disabled="disableNext" class="button button--primary" @click="nextAction">
          <slot name="btnNextTxt">{{ nextText }}</slot>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: 'Modal Title'
    },
    showPrev: {
      type: Boolean,
      default: false
    },
    showNext: {
      type: Boolean,
      default: false
    },
    prevText: {
      type: String,
      default: 'Schließen'
    },
    nextText: {
      type: String,
      default: 'Weiter'
    },
    rowReverse: {
      type: Boolean,
      default: false
    },
    disableNext: {
      type: Boolean,
      default: false
    },
    disablePrev: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    prevAction() {
      this.$emit('prev')
    },
    nextAction() {
      this.$emit('next')
    }
  }
}
</script>
